import i18n from 'Portals/Supplier/utils/i18nService'

export const getDefaultMessage = () => (
	<>
		{i18n.t('pages:registrationDocument.message.default.text')}
		<br />
		<b>{i18n.t('pages:registrationDocument.message.default.boldText')}</b>
	</>
)

export const getSubmissionMessage = () => i18n.t('pages:registrationDocument.message.submission')
